var render = function render() {
  var _vm$currentVehicle,
    _vm$currentVehicle2,
    _vm$editEngineSelecti,
    _vm$tempEngineSelecte,
    _vm$editSubmodelSelec,
    _vm$tempSubmodelSelec
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.cancelVehicleChange,
          expression: "cancelVehicleChange",
        },
      ],
    },
    [
      _vm.isForced
        ? _c("div", {
            staticClass: "force-car-overlay",
            on: {
              click: _vm.cancelForceCar,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isRecentVehiclesModalShown
        ? _c(
            "FcoModal",
            {
              attrs: {
                "title-text": _vm.fcoM(
                  "rs.homeMain.recentVehicles",
                  "Recent Vehicles"
                ),
                size: "lg",
                closeMsg: _vm.fcoM("common.close", "Close"),
              },
              on: {
                close: _vm.closeRecentVehiclesModal,
              },
            },
            [
              _c(
                "RecentVehicles",
                _vm._b(
                  {
                    on: {
                      "vehicle-selected": _vm.handleRecentVehicleSelected,
                    },
                  },
                  "RecentVehicles",
                  _vm.$props,
                  false
                )
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: {
                    slot: "footer",
                    type: "button",
                  },
                  on: {
                    click: _vm.closeRecentVehiclesModal,
                  },
                  slot: "footer",
                },
                [_vm._v(_vm._s(_vm.fcoM("common.close", "Close")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isVehicleInfoShown &&
      (_vm$currentVehicle = _vm.currentVehicle) !== null &&
      _vm$currentVehicle !== void 0 &&
      _vm$currentVehicle.id
        ? _c("VehicleCustomerInfo", {
            attrs: {
              "vehicle-id":
                (_vm$currentVehicle2 = _vm.currentVehicle) === null ||
                _vm$currentVehicle2 === void 0
                  ? void 0
                  : _vm$currentVehicle2.id,
              "shop-customer-id": _vm.shopCustomer ? _vm.shopCustomer.id : null,
              attributes: _vm.currentVehicle.answeredAttributes,
            },
            on: {
              "remove-attribute": function ($event) {
                return _vm.removeAttributes([$event])
              },
              save: _vm.handleVehicleInfoSave,
              close: _vm.closeVehicleInfoModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "vehicle-lookup",
            {
              forced: _vm.isForced,
            },
          ],
          attrs: {
            id: "vehicle",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "vehicle-select-container",
            },
            [
              _vm.isVehicleError
                ? _c(
                    "div",
                    [
                      _vm.isVehicleLoading
                        ? _c("FcoSpinner")
                        : _c(
                            "div",
                            {
                              staticClass: "alert alert-danger mb-0",
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fcoM(
                                      "rs.homeMain.errorLoadingVehicleSelector",
                                      "Error loading vehicle selector"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "JavaScript:void(0)",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.loadCurrentVehicle()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.fcoM("common.reload", "Reload"))
                                  ),
                                ]
                              ),
                            ]
                          ),
                    ],
                    1
                  )
                : [
                    _vm.currentVehicle &&
                    !_vm.addVehicleOnlyMode &&
                    !_vm.changeVehicleMode
                      ? [
                          _vm.currentVehicle.shopVehicleDescriptor
                            ? _c(
                                "p",
                                {
                                  staticClass: "d-block d-lg-none",
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVehicle.shopVehicleDescriptor
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVehicle.vin
                            ? _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.fcoM(
                                        "rs.homeMain.vinTitle",
                                        "VIN:"
                                      ) || " "
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-uppercase",
                                  },
                                  [_vm._v(" " + _vm._s(_vm.currentVehicle.vin))]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm.currentVehicle.answeredAttributes.length ||
                            _vm.editMode
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mb-1",
                                  },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        staticClass: "text-break",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.fcoM(
                                              "common.vehicleAttributes",
                                              "Vehicle Attributes"
                                            ) || " "
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.editMode
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mb-2",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "position-relative mt-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "bg-white custom-legend",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fcoM(
                                                  "attributes.engine",
                                                  "Engine"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("fco-search-select", {
                                          ref: "editEngineSelect",
                                          staticClass:
                                            "ymm-input d-none d-sm-block",
                                          attrs: {
                                            value:
                                              (_vm$editEngineSelecti =
                                                _vm.editEngineSelection) ===
                                                null ||
                                              _vm$editEngineSelecti === void 0
                                                ? void 0
                                                : _vm$editEngineSelecti.id,
                                            "allow-empty": false,
                                            placeholder:
                                              ((_vm$tempEngineSelecte =
                                                _vm.tempEngineSelected) ===
                                                null ||
                                              _vm$tempEngineSelecte === void 0
                                                ? void 0
                                                : _vm$tempEngineSelecte.value) ||
                                              `${_vm.fcoM(
                                                "rs.homeMain.selectEngine",
                                                "Select Engine"
                                              )} (${_vm.fcoM(
                                                "common.optional",
                                                "Optional"
                                              )})`,
                                            grid: true,
                                            "grid-rows": 14,
                                            options: _vm.engines,
                                            mapOption: function (option) {
                                              return {
                                                label: option.value,
                                                value: option.id,
                                              }
                                            },
                                            "menu-class": ["ymm-results"],
                                            "data-qa": "ymm-edit-engine-select",
                                          },
                                          on: {
                                            focus: function ($event) {
                                              return _vm.handleFocus("engine")
                                            },
                                            blur: function ($event) {
                                              return _vm.handleBlur("engine")
                                            },
                                            select: _vm.handleEngineSelect,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            staticClass:
                                              "custom-select d-sm-none",
                                            attrs: {
                                              "data-qa":
                                                "ymm-mobile-edit-engine-select",
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.handleEngineSelect(
                                                  JSON.parse(
                                                    $event.target.value
                                                  )
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  disabled: "",
                                                  selected: "",
                                                  hidden: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.fcoM(
                                                      "rs.homeMain.selectEngine",
                                                      "Select Engine"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.engines,
                                              function (engine) {
                                                var _vm$editEngineSelecti2
                                                return _c(
                                                  "option",
                                                  {
                                                    key: engine.id,
                                                    domProps: {
                                                      value:
                                                        JSON.stringify(engine),
                                                      selected:
                                                        ((_vm$editEngineSelecti2 =
                                                          _vm.editEngineSelection) ===
                                                          null ||
                                                        _vm$editEngineSelecti2 ===
                                                          void 0
                                                          ? void 0
                                                          : _vm$editEngineSelecti2.id) ===
                                                        engine.id,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(engine.value) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "position-relative mt-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "bg-white custom-legend",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fcoM(
                                                  "attributes.submodel",
                                                  "Submodel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("fco-search-select", {
                                          ref: "editSubmodelSelect",
                                          staticClass:
                                            "ymm-input d-none d-sm-block",
                                          attrs: {
                                            value:
                                              (_vm$editSubmodelSelec =
                                                _vm.editSubmodelSelection) ===
                                                null ||
                                              _vm$editSubmodelSelec === void 0
                                                ? void 0
                                                : _vm$editSubmodelSelec.id,
                                            "allow-empty": false,
                                            placeholder:
                                              ((_vm$tempSubmodelSelec =
                                                _vm.tempSubmodelSelected) ===
                                                null ||
                                              _vm$tempSubmodelSelec === void 0
                                                ? void 0
                                                : _vm$tempSubmodelSelec.value) ||
                                              `${_vm.fcoM(
                                                "rs.homeMain.selectSubmodel",
                                                "Select Submodel"
                                              )} (${_vm.fcoM(
                                                "common.optional",
                                                "Optional"
                                              )})`,
                                            grid: true,
                                            "grid-rows": 14,
                                            options: _vm.submodels,
                                            mapOption: function (option) {
                                              return {
                                                label: option.value,
                                                value: option.id,
                                              }
                                            },
                                            "menu-class": ["ymm-results"],
                                            "data-qa":
                                              "ymm-edit-submodel-select",
                                          },
                                          on: {
                                            focus: function ($event) {
                                              return _vm.handleFocus("submodel")
                                            },
                                            blur: function ($event) {
                                              return _vm.handleBlur("submodel")
                                            },
                                            select: _vm.handleSubmodelSelect,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            staticClass:
                                              "custom-select d-sm-none",
                                            attrs: {
                                              "data-qa":
                                                "ymm-mobile-edit-submodel-select",
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.handleSubmodelSelect(
                                                  JSON.parse(
                                                    $event.target.value
                                                  )
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  disabled: "",
                                                  selected: "",
                                                  hidden: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.fcoM(
                                                      "rs.homeMain.selectSubmodel",
                                                      "Select Submodel"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.submodels,
                                              function (submodel) {
                                                var _vm$editSubmodelSelec2
                                                return _c(
                                                  "option",
                                                  {
                                                    key: submodel.id,
                                                    domProps: {
                                                      value:
                                                        JSON.stringify(
                                                          submodel
                                                        ),
                                                      selected:
                                                        ((_vm$editSubmodelSelec2 =
                                                          _vm.editSubmodelSelection) ===
                                                          null ||
                                                        _vm$editSubmodelSelec2 ===
                                                          void 0
                                                          ? void 0
                                                          : _vm$editSubmodelSelec2.id) ===
                                                        submodel.id,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(submodel.value) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                attrs: {
                                  "data-qa": "vehicle-attributes-list",
                                },
                              },
                              [
                                _vm.editMode
                                  ? _vm._l(
                                      _vm.vehicleSelectedAttributes,
                                      function (attribute) {
                                        return _c("VehicleAttribute", {
                                          key: `edit=${attribute.attributeId}`,
                                          staticClass: "ml-0 mb-1 text-break",
                                          class: {
                                            "strike-through":
                                              _vm.attributeRemovalQueue.includes(
                                                attribute.attributeId
                                              ),
                                          },
                                          attrs: {
                                            attribute: attribute,
                                            tag: "li",
                                          },
                                          on: {
                                            remove: function ($event) {
                                              return _vm.toggleAttributeInRemovalQueue(
                                                attribute.attributeId
                                              )
                                            },
                                          },
                                        })
                                      }
                                    )
                                  : _vm._l(
                                      _vm.currentVehicle.answeredAttributes,
                                      function (attribute) {
                                        return _c(
                                          "li",
                                          {
                                            key: `nonEdit-${attribute.attributeId}`,
                                            staticClass: "ml-0 mb-1 text-break",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  `${attribute.attributeDescription}: ${attribute.displayDescription}`
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.editMode
                              ? _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      on: {
                                        click: _vm.updateVehicleAttributes,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fcoM(
                                            "rs.homeMain.updateVehicle",
                                            "Update Vehicle"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-link font-weight-bold",
                                      on: {
                                        click: _vm.disableVehicleEditMode,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fcoM("common.cancel", "Cancel")
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          !_vm.editMode
                            ? _c(
                                "div",
                                {
                                  staticClass: "mb-2",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "font-weight-bold",
                                      attrs: {
                                        href: "#",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.enabledVehicleEditMode.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.currentVehicle.answeredAttributes
                                        .length
                                        ? [
                                            _c("Icon", {
                                              attrs: {
                                                name: "pencil",
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.fcoM(
                                                    "rs.homeMain.editVehicleAttributes",
                                                    "Edit Vehicle Attributes"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        : [
                                            _c("Icon", {
                                              attrs: {
                                                name: "plus",
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.fcoM(
                                                    "rs.homeMain.addVehicleAttributes",
                                                    "Add Vehicle Attributes"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.motorData
                            ? _c(
                                "FcoLink",
                                {
                                  staticClass: "qaa-vehicle-data-specs",
                                  attrs: {
                                    to: "/vehicle-documents",
                                    href: _vm.fcoUrl(
                                      "/vehicleDocument/viewer.html"
                                    ),
                                    "data-qa": "vehicle-data-link",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function () {
                                          return _vm.trackVehicleSpecsClick(
                                            _vm.VehicleSpecsFrom
                                              .VEHICLE_SELECTOR
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("Icon", {
                                        staticClass: "icon-up-3 mr-1 text-sm",
                                        attrs: {
                                          name: "file-text",
                                        },
                                      }),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.fcoM(
                                              "rs.homeMain.vehicleDocs",
                                              "Vehicle Data/Specs."
                                            ) || " "
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.shopCustomer
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "d-block font-weight-bold mt-1 qaa-vehicle-add-customer",
                                  attrs: {
                                    href: "#",
                                    id: "vsAddCustomer",
                                    "data-qa": "vs-add-customer-link",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleVehicleInfoModal.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("Icon", {
                                    staticClass: "icon-small icon-up-2",
                                    attrs: {
                                      name: "user-plus",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ml-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fcoM(
                                            "rs.managecustomers.addCustomer",
                                            "Add Customer"
                                          ) || " "
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "a",
                                {
                                  staticClass:
                                    "d-block font-weight-bold mt-1 qaa-vehicle-edit-customer",
                                  attrs: {
                                    href: "#",
                                    id: "vsAddCustomer",
                                    "data-qa": "vs-edit-customer-link",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleVehicleInfoModal.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("Icon", {
                                    staticClass: "icon-small icon-up-2",
                                    attrs: {
                                      name: "user",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ml-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fcoM(
                                            "rs.managecustomers.editCustomer",
                                            "Edit Customer Info"
                                          ) || " "
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _vm.shopCustomer
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-3",
                                },
                                [
                                  _c("h4", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.fcoM(
                                          "common.customer",
                                          "Customer"
                                        ) || " "
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "FcoLink",
                                    {
                                      attrs: {
                                        to: `/customers/details/${_vm.shopCustomer.id}`,
                                        href: _vm.fcoUrl(
                                          `/customers/#/details/${_vm.shopCustomer.id}`
                                        ),
                                        "data-qa": "vs-view-customer-link",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.shopCustomer.firstName) +
                                            " " +
                                            _vm._s(_vm.shopCustomer.lastName)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$store.getters.isMitchell1User
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center flex-wrap mt-3",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "secondary qaa-vehicle-change mx-1 mb-1",
                                      attrs: {
                                        "data-qa": "vs-change-customer-button",
                                      },
                                      on: {
                                        click: _vm.changeVehicle,
                                      },
                                    },
                                    [
                                      _c("Icon", {
                                        staticClass:
                                          "d-none d-sm-inline text-sm icon-up-2",
                                        attrs: {
                                          name: "car",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.fcoM(
                                              "rs.homeMain.changeVehicle",
                                              "Change Vehicle"
                                            ) || " "
                                          ) +
                                          "\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button secondary qaa-vehicle-clear mx-1 mb-1",
                                      attrs: {
                                        "data-qa": "vs-remove-vehicle-button",
                                      },
                                      on: {
                                        click: _vm.removeSelectedVehicle,
                                      },
                                    },
                                    [
                                      _c("Icon", {
                                        staticClass:
                                          "d-none d-sm-inline text-sm icon-up-2",
                                        attrs: {
                                          name: "trash",
                                        },
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.fcoM(
                                            "rs.getparts.clearSelectedVehicle",
                                            "Clear Vehicle"
                                          ) || " "
                                        ) + "\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !_vm.currentVehicle ||
                              _vm.addVehicleOnlyMode ||
                              _vm.changeVehicleMode,
                            expression:
                              "!currentVehicle || addVehicleOnlyMode || changeVehicleMode",
                          },
                        ],
                      },
                      [
                        _vm.changeVehicleMode
                          ? _c(
                              "a",
                              {
                                staticClass: "d-inline-block mb-1",
                                attrs: {
                                  href: "#",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.cancelVehicleChange.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("Icon", {
                                  attrs: {
                                    name: "chevron-left",
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.fcoM(
                                          "rs.getparts.cancelVehicleChange",
                                          "Cancel Vehicle Change"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "PlateToVin",
                          _vm._b(
                            {
                              staticClass: "plate-to-vin",
                              on: {
                                "vehicle-selected": _vm.handleVehicleSelected,
                              },
                            },
                            "PlateToVin",
                            _vm.$props,
                            false
                          )
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "vs-section-divider",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.fcoM("rs.homeMain.or", "or") || " ")
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "YearMakeModel",
                          _vm._b(
                            {
                              key: _vm.ymmRefreshKey,
                              ref: "ymm",
                              on: {
                                "vehicle-selected": _vm.handleVehicleSelected,
                              },
                            },
                            "YearMakeModel",
                            _vm.$props,
                            false
                          )
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "vs-section-divider",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.fcoM("rs.homeMain.or", "or") || " ")
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "VinLookup",
                          _vm._b(
                            {
                              staticClass: "vin-lookup",
                              on: {
                                "vehicle-selected": _vm.handleVehicleSelected,
                              },
                            },
                            "VinLookup",
                            _vm.$props,
                            false
                          )
                        ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _vm.isForced
            ? _c(
                "div",
                {
                  staticClass: "d-md-flex alert-danger p-3",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-md flex-grow-1 d-inline-flex align-items-center",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.fcoM(
                            "rs.homeMain.selectCar",
                            "Please select a vehicle to continue."
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-danger mb-0",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.cancelForceCar.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.fcoM("common.cancel", "Cancel")))]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }